import React, { useEffect, useState, useCallback } from "react";
import toast from "react-hot-toast";
import ProfileNav from "../../components/ProfileNav";
import { getOrganisations } from "../../services/organisation";
import Pagination from "../../components/Pagination";
import CreateDomain from "./CreateDomain";
import { useAuth } from "../../context/AuthContextProvider";

const Organisations = () => {
  const [organisations, setOrganisations] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [openDomain, setOpenDomain] = useState(false);
  const [selectedOrganisation, setSelectedOrganisation] = useState(null);
  const { userrole } = useAuth();

  const itemsPerPage = 100;

  const fetchOrganisations = useCallback(async () => {
    setLoading(true);
    try {
      const res = await getOrganisations(currentPage, itemsPerPage);
      setOrganisations(res.data?.data);
      setTotalRecords(res.data.totalRecords);
      setLoading(false);
    } catch (error) {
      if (error.response) {
        toast.error(error?.response?.data?.message);
        setLoading(false);
      }
    } finally {
      setLoading(false);
    }
  }, [currentPage]);

  useEffect(() => {
    fetchOrganisations();
  }, [fetchOrganisations]);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <div className="h-screen">
      <div className="flex justify-between items-center py-4">
        <h1 className="text-navy-blue text-2xl font-bold">Organisations</h1>
        <div>
          <ProfileNav />
        </div>
      </div>

      <div className="flex justify-end">
        <button
          className={`h-10 px-4 rounded-md text-sm font-medium bg-primary text-white cursor-pointer ${
            userrole.role === "Business Support Checker" ? "hidden" : "block"
          }`}
          onClick={() => {
            setOpenDomain(true);
            setSelectedOrganisation(null);
          }}
        >
          Create Domain
        </button>
      </div>

      <div className="bg-white w-full mt-4 rounded-xl shadow-sm overflow-x-auto">
        <div className="flex items-center justify-between px-4 py-3 border-b">
          <div>
            <Pagination
              totalItems={totalRecords}
              itemsPerPage={itemsPerPage}
              paginate={paginate}
              currentPage={currentPage}
            />
          </div>
        </div>

        <table className="w-full text-sm">
          <thead className="bg-gray-50">
            {/* Column titles */}
            <tr className="text-left border-b text-gray-600 text-xs uppercase tracking-wide">
              <th className="px-3 py-2">Id</th>
              <th className="px-3 py-2">Name</th>
              <th className="px-3 py-2">Domain</th>
              <th className="px-3 py-2">Logo</th>
              <th className="px-3 py-2">Favicon</th>
              <th className="px-3 py-2">Primary Color</th>
              <th className="px-3 py-2">Secondary Color</th>
              <th className="px-3 py-2">Email</th>
              <th className="px-3 py-2">Date Created</th>
              <th className="px-3 py-2">Date Updated</th>
              <th className="px-3 py-2">isDefault</th>
              <th className="px-3 py-2">isActive</th>
            </tr>
          </thead>

          {/* Body */}
          <tbody className="divide-y divide-gray-200">
            {loading ? (
              <tr>
                <td colSpan="10" className="text-center py-6 text-gray-500">
                  Fetching organisations...
                </td>
              </tr>
            ) : organisations.length === 0 ? (
              <tr>
                <td colSpan="10" className="text-center py-6 text-gray-500">
                  No organisations found
                </td>
              </tr>
            ) : (
              organisations.map((org) => (
                <tr
                  key={org.id}
                  onClick={() => {
                    setOpenDomain(true);
                    setSelectedOrganisation(org);
                  }}
                  className=" hover:bg-[rgba(var(--primary-rgb),0.5)] transition text-sm text-gray-700 cursor-pointer"
                >
                  <td className="px-3 py-2">{org.id}</td>
                  <td className="px-3 py-2">{org.name}</td>
                  <td className="px-3 py-2">{org.domain}</td>
                  <td className="px-3 py-2">{org.logo}</td>
                  <td className="px-3 py-2">{org.favIcon}</td>
                  <td className="px-3 py-2">{org.primaryColor}</td>
                  <td className="px-3 py-2">{org.secondaryColor}</td>
                  <td className="px-3 py-2">{org.email}</td>
                  <td className="px-3 py-2">
                    {" "}
                    {new Date(org.dateCreated).toLocaleDateString("en-US", {
                      year: "numeric",
                      month: "long",
                      day: "numeric",
                    })}
                  </td>
                  <td className="px-3 py-2">
                    {new Date(org.dateUpdated).toLocaleDateString("en-US", {
                      year: "numeric",
                      month: "long",
                      day: "numeric",
                    })}
                  </td>
                  <td className="px-3 py-2">
                    {org.isDefault ? "true" : "false"}
                  </td>
                  <td className="px-3 py-2">
                    {org.isActive ? "true" : "false"}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
      {openDomain && (
        <CreateDomain
          onClose={() => {
            setOpenDomain(false);
            setSelectedOrganisation(null);
          }}
          organisation={selectedOrganisation}
        />
      )}
    </div>
  );
};

export default Organisations;
